var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122:11535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00917 1.0868C6.27029 0.484639 7.12424 0.484639 7.38536 1.0868L8.42201 3.4774C8.53068 3.72802 8.76702 3.89973 9.03895 3.92564L11.6329 4.17282C12.2863 4.23507 12.5502 5.04723 12.0582 5.48164L10.1049 7.20629C9.90013 7.38709 9.80986 7.66493 9.86925 7.93156L10.4357 10.4749C10.5784 11.1156 9.88758 11.6175 9.32239 11.2838L7.07856 9.95911C6.84333 9.82023 6.5512 9.82023 6.31597 9.95911L4.07214 11.2838C3.50695 11.6175 2.8161 11.1156 2.95879 10.4749L3.52528 7.93155C3.58467 7.66493 3.4944 7.38709 3.28963 7.20629L1.33637 5.48164C0.844375 5.04723 1.10826 4.23507 1.76164 4.17282L4.35558 3.92564C4.62751 3.89973 4.86385 3.72802 4.97253 3.4774L6.00917 1.0868Z",
    fill: "#455AFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122:11535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.3649,
    height: 12,
    fill: "white",
    transform: "translate(0.697266)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1915fb8b.svg";
export { ForwardRef as ReactComponent };